module.exports = __webpack_public_path__ + "img/new_05_workshop_1.2b91693d.jpg";